import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WizardStepIndex } from "../../shared/enums/WizardStep";
import { cartHelper } from "../../shared/helpers/cartHelper";
import logo from "../../static/Rototilt_logo.svg";
import { useCartOptional } from "../../store/hooks/useCartOptional";
import { useCartProduct } from "../../store/hooks/useCartProduct";
import { useWizard } from "../../store/hooks/useWizard";
import Cart from "../Cart/Cart";
import ButtonPrimary from "../shared/ButtonPrimary";
import "./Topbar.scss";

const Topbar = () => {
  const wizard = useWizard();
  const cartProduct = useCartProduct();
  const cartOptional = useCartOptional();
  const { t } = useTranslation("topbar");
  const [counter, setCounter] = useState<number>(0);
  const [showCart, setShowCart] = useState<boolean>(false);

  useEffect(() => {
    const count = cartHelper.countSelectedProducts({
      cartOptional,
      cartProduct,
    });
    setCounter(count);
  }, [cartProduct, cartOptional]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!wizard) {
    return <></>;
  }

  const onClick = () => {
    setShowCart(true);
  };

  const toggleDrawer = (
    event: React.KeyboardEvent | React.MouseEvent,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }

    setShowCart(false);
  };

  const onCartCloseClick = () => {
    setShowCart(false);
  };

  return (
    <>
      <header>
        <div className="topbarContainer">
          <a href="https://www.rototilt.com/">
            <img width="136" alt="logo" src={logo} className="topBarLogo" />
          </a>
          {wizard.activeStepIndex !== WizardStepIndex.Done && (
            <ButtonPrimary
              onClick={onClick}
              text={`${counter} ${t("products").toUpperCase()}`}
            />
          )}
        </div>
      </header>
      <Cart
        cartOptional={cartOptional}
        cartProduct={cartProduct}
        onCloseClick={onCartCloseClick}
        showCart={showCart}
        toggleDrawer={toggleDrawer}
      />
    </>
  );
};

export default Topbar;
